module.exports = __webpack_public_path__ + "img/folder-arrow-up.06f72e53.svg";